import { isAuthenticated } from "@/routers/router-guardians"

const routes = [
  {
    path: "/dashboard/tasks",
    name: "tasks",
    component: () => import("@/modules/tasks/pages/Tasks.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default routes
